<template>
<div class="spinner-container">
  <div class="pulse-spinner"></div>
</div>
</template>

<script>
export default {
  name: 'AppLoading'
}
</script>

<style scoped>
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.pulse-spinner {
  width: 50px;
  height: 50px;
  background-color: #f9ab00;
  border-radius: 50%;
  animation: pulse 1s infinite ease-in-out;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.5;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>